export const environment = {
  production: true,
  showStoreLog: false,
  appUrl: 'https://www.goponkw.com/',
  //appUrl: 'https://goponsitedev.softlinktest.com/',

  DEFAULT_LANGUAGE: 'ar',
  DEFAULT_TIMEOUT: 10000,
  //API_BASE_URL: 'https://goponapi.goponkw.com/api/v3/',
  API_BASE_URL: 'https://goponapidev.softlinktest.com/api/v3/',
  //API_BASE_URL: 'http://192.168.0.100:5000/api/v3/',

  ASSETS_PATH: './assets',
  PROJECT_NAME: 'Gopon',
  fb_pixel_config: {
    enabled: true,
    pixelId: '963461598368576',
  },
  snap_pixel_config: {
    enabled: true,
    pixelId: '03681d1d-7af2-4b2a-8d6f-780ecc071e5f',
  },
};
